// extracted by mini-css-extract-plugin
module.exports = {"SidePane":"SidePane___SHK2X","loading":"loading___1xBxA"};